import React, { useState, useEffect } from "react";

import contactImg from "../assest/images/contact-us/cloud.webp";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import { useLocation } from "react-router-dom";

import ImgAdven from "../assest/images/banner-img/separtor.png";
import { apiRequest } from "../services/allApi";
import { errorAlert, successAlert } from "../services/sweetAlert";
import Loader from "../component/loader.jsx";

function Gallary() {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [galleryData, setGalleryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const Gallery = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("gallery");
      setIsLoading(false);
      if (res?.success) {
        setGalleryData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    Gallery();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <div className="container-fulid">
        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg} alt="cloud" />
          </div>
        </div>
        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title">Gallary</h3>
            <ul className="breadcrumb-menu">
              <li>
                <a className="text-white" href="index.html">
                  Home
                </a>
              </li>
              <li>-</li>
              <li className="active">Gallary</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="text-center mb-5">
          <div className="about-content">
            <div className="section-title mb-40">
              <span>Gallary</span>
              <h2>PHOTO'S FROM TRAVELLERS</h2>

              <img src={ImgAdven} alt="" />
            </div>
          </div>
        </div>

        <LightGallery
          className="lightgallery-box" // आपका ओरिजिनल क्लास
          speed={500} // आपकी स्पीड
          plugins={[lgThumbnail, lgZoom]} // आपके प्लगइन्स
          elementClassNames="row" // आपका रो सिस्टम
        >
          {/* यहाँ मैप शुरू होता है */}
          {galleryData && galleryData.length > 0 ? (
            galleryData.map((item, index) => (
              <a
                key={index}
                href={`${BASE_URL}${item.image}`} // इमेज का बड़ा वर्ज़न
                className="col-lg-4 mb-4" // बूटस्ट्रैप कॉलम
              >
                <img
                  src={`${BASE_URL}${item.image}`} // थंबनेल इमेज
                  className="lightgallery-box-img img-fluid rounded"
                  alt={`img-${index}`}
                />
              </a>
            ))
          ) : (
            <p className="text-center w-100">Loading Images...</p>
          )}
        </LightGallery>
      </div>
    </div>
  );
}

export default Gallary;
